export function resolveSpecies(detections, library) {
    const speciesMap = new Map();
    for (const entry of library) {
        if (entry.species) {
            for (const synonym of entry.synonyms) {
                speciesMap.set(synonym.toLowerCase().trim(), entry.species);
            }
            speciesMap.set(entry.canonicalName.toLowerCase().trim(), entry.species);
        }
    }
    const speciesCategories = new Set(['tree_nuts', 'fish', 'crustaceans', 'crustacean_shellfish']);
    return detections.map((detection) => {
        if (!speciesCategories.has(detection.allergenCategory)) {
            return detection;
        }
        if (detection.species) {
            return detection; // Already has species
        }
        // Try to resolve from species map
        const resolved = speciesMap.get(detection.matchedTerm.toLowerCase().trim());
        if (resolved) {
            return { ...detection, species: resolved };
        }
        // Flag as needing review for species
        return { ...detection, species: undefined };
    });
}
//# sourceMappingURL=resolveSpecies.js.map